import { Theme } from "@screencloud/screencloud-ui-components";
import styled, { css } from "styled-components";

export const LayoutCards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 339px);
  min-width: 1220px;
  gap: 48px;
  padding: 0 50px;
  width: 100%;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  overflow: auto;

  @media (max-width: ${Theme.break.small}) {
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: calc(100% - 100px);
    scrollbar-width: none;
  }
`;

export const LayoutCardContainer = styled.div<{ isSelected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;

  ${({ isSelected }) =>
    isSelected &&
    css`
      .layout-label {
        color: var(--color-white-100, #fff);
        background: var(--color-black-100, #000);
      }
    `}

  :hover {
    .layout-label {
      color: var(--color-white-100, #fff);
      background: var(--color-gray-500, #62636a);
    }
    .layout-card {
      transform: scale(1.05);
    }
    .cover-overlay {
      opacity: 0;
    }
  }
`;

export const LayoutCard = styled.div<{ selected: boolean }>`
  aspect-ratio: 16/9;
  border-radius: 8px;
  cursor: pointer;
  overflow: hidden;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    transform: scale(1.02);
  }

  img {
    object-fit: cover;
  }
`;

export const LayoutLabel = styled.div`
  display: flex;
  height: var(--size-md, 32px);
  padding: 0px var(--spacing-lg, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--spacing-xxs, 4px);

  border-radius: var(--radius-lg, 16px);
  border: 1px solid var(--color-gray-100, #e2e3e5);
  background: var(--color-white-100, #fff);

  box-shadow: 0px 1px 2px 0px var(--color-black-5, rgba(0, 0, 0, 0.05));

  color: var(--color-black-100, #000);

  font-size: var(--font-size-sm, 14px);
  font-weight: 700;
  line-height: var(--font-line-height-sm, 20px);
`;

export const LoadingAnimation = styled.div`
  width: 280px;
  height: 280px;
  position: relative;
  border-radius: 100%;
  background: linear-gradient(135deg, #fff5cc -0.01%, #fee266 99.99%), #ffffff;
  svg {
    display: inline-block;
    width: 86px;
    position: absolute;
    filter: drop-shadow(0px 10px 20px rgba(0, 0, 0, 0.1));
    &.left {
      animation: left 1.6s ease 0.4s infinite normal forwards;
    }
    &.center {
      animation: center 2s ease 0s infinite normal forwards;
    }
    &.right {
      animation: right 2.6s ease 0.2s infinite normal forwards;
    }
  }

  @keyframes left {
    0% {
      transform: translateY(-20px) translateX(0) scale(1.5) rotate(-40deg);
      opacity: 0.1;
    }
    15% {
      opacity: 1;
    }
    70% {
      transform: translateY(70px) translateX(97px) scale(0.8) rotate(10deg);
      opacity: 1;
    }
    100% {
      transform: translateY(200px) translateX(97px) scale(0.2) rotate(20deg);
      opacity: 0;
    }
  }
  @keyframes center {
    0% {
      transform: translateY(-20px) translateX(97px) scale(1.7);
      opacity: 0.1;
    }
    15% {
      opacity: 1;
    }
    60% {
      transform: translateY(60px) translateX(97px) scale(0.8);
      opacity: 1;
    }
    100% {
      transform: translateY(200px) translateX(97px) scale(0.2);
      opacity: 0;
    }
  }
  @keyframes right {
    0% {
      transform: translateY(-20px) translateX(212px) scale(1.5) rotate(40deg);
      opacity: 0.1;
    }
    15% {
      opacity: 1;
    }
    60% {
      transform: translateY(70px) translateX(97px) scale(0.8) rotate(10deg);
      opacity: 1;
    }
    100% {
      transform: translateY(200px) translateX(97px) scale(0.2) rotate(-20deg);
      opacity: 0;
    }
  }
`;

export const GeneratingContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;
